module.exports = __webpack_public_path__ + "icofont.ea6b50ee81ded0716b21.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/icofont.eot?v=1.0.0-beta
// module id = ../../../../../src/assets/fonts/icofont.eot?v=1.0.0-beta
// module chunks = styles